import { render, staticRenderFns } from "./StatCard.vue?vue&type=template&id=f9b0a6e0&scoped=true"
import script from "./StatCard.vue?vue&type=script&lang=js"
export * from "./StatCard.vue?vue&type=script&lang=js"
import style0 from "./StatCard.vue?vue&type=style&index=0&id=f9b0a6e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b0a6e0",
  null
  
)

export default component.exports